import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

import packageInfo from '../package.json';
import { environment } from '@env/environment';
import { initMixpanelFromEnvironment } from './app/analytics/mixpanel-bootstrap';
import { initSentryFromEnvironment } from './app/sentry/sentry-bootstrap';

console.log('%c⧭ Version ', 'color: #00861b; font-size: 16px; font-weight: 600', packageInfo.version);
// if (environment.production) {
//   // close log on production
//   console.log = () => {};
// }

initSentryFromEnvironment(environment, {
  release: `jretail-basic@${packageInfo.version}`,
});

initMixpanelFromEnvironment(environment);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
